import { render, staticRenderFns } from "./group_choose.vue?vue&type=template&id=6ad929cc&scoped=true&"
import script from "./group_choose.vue?vue&type=script&lang=js&"
export * from "./group_choose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad929cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad929cc')) {
      api.createRecord('6ad929cc', component.options)
    } else {
      api.reload('6ad929cc', component.options)
    }
    module.hot.accept("./group_choose.vue?vue&type=template&id=6ad929cc&scoped=true&", function () {
      api.rerender('6ad929cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/groups/choose/group_choose.vue"
export default component.exports